<template>
  <div class="header">
    <template v-for="(item, index) of items">
      <div class="header__item" :key="index">
        <div
          role="button"
          class="header__item__button"
          :class="{
            'header__item__button--active': modalSectionSelected === index + 1,
            disabled: (!booleanIsFromMexico && !getIsGSUser) || (!getIsGSUser && !getIsB2CPremium && index === 1),
          }"
          @click="onItemClick(index)"
        >
          <div class="header__item__button__icon">
            <img :src="modalSectionSelected === index + 1 ? item.iconActive : item.icon" />
          </div>
          <div class="header__item__button__text">{{ isMobileTextVisible ? item.textMobile : item.text }}</div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapState } from 'vuex';

export default {
  name: 'Header',
  data() {
    return {
      items: [
        {
          text: 'Videoplayer',
          textMobile: 'Videoplayer',
          icon: 'https://golstatsimages.blob.core.windows.net/todoelfut/icn_videoplayer_green.svg',
          iconActive: 'https://golstatsimages.blob.core.windows.net/todoelfut/icn_videoplayer_blue.svg',
        },
        {
          text: 'Tus playlists',
          textMobile: 'Tus playlists',
          icon: 'https://golstatsimages.blob.core.windows.net/todoelfut/icn_my_playlists_green.svg',
          iconActive: 'https://golstatsimages.blob.core.windows.net/todoelfut/icn_my_playlists_dark.svg',
        },
      ],
    };
  },
  computed: {
    ...mapState(['windowWidth']),
    ...mapState('mediaModal', ['modalInitialState', 'modalSectionSelected']),
    ...mapState('loginGeneral', ['booleanIsFromMexico']),
    ...mapGetters('loginGeneral', ['getIsGSUser', 'getIsB2CPremium']),
    isMobileTextVisible() {
      return this.windowWidth < 1260;
    },
  },
  watch: {
    'modalInitialState.mainSectionType': {
      immediate: true,
      handler(newValue) {
        this.itemSelectedIndex = newValue;
      },
    },
    itemSelectedIndex: {
      immediate: true,
      handler(newValue) {
        this.setModalSectionSelected(newValue);
      },
    },
  },
  methods: {
    ...mapMutations('mediaModal', ['setModalSectionSelected']),
    onItemClick(itemIndex) {
      // if (itemIndex === 4) {
      //   return;
      // }
      if (!this.getIsGSUser && !this.getIsB2CPremium && itemIndex === 1) {
        return;
      }
      if (this.booleanIsFromMexico || this.getIsGSUser) {
        this.setModalSectionSelected(itemIndex + 1);
      }
    },
  },
};
</script>

<style scoped lang="scss">
$blue: #132839;
$green: #cbee6b;
.header {
  font-size: 1rem;
  width: 100%;
  padding: 10px 40px;
  border-radius: 10px;
  background-color: $blue;
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 1.625em;
  font-family: Roboto-Regular, sans-serif;

  &__item {
    width: fit-content;
    display: flex;
    flex-direction: column;
    justify-content: center;

    &__text {
      font-size: 0.8em;
      margin-top: 0.5em;
      font-family: Heebo, sans-serif;
      font-weight: 300;
      color: $green;
      display: none;
    }

    &__button {
      padding: 0 2em;
      width: fit-content;
      display: flex;
      justify-content: center;
      align-items: center;
      color: $green;
      border-radius: 12px;
      border: solid 1px $green;
      font-size: 1.1875em;
      height: 2.53em;
      cursor: pointer;
      position: relative;

      &__icon {
        height: 32px;
        width: 32px;
        margin-right: 1rem;

        & img {
          height: 32px;
          width: 32px;
        }
      }

      & > div.coming-soon {
        position: absolute;
        font-size: 0.6em;
        bottom: -1.8em;
        background-color: #ef3536;
        color: white;
        border-radius: 4px;
        padding: 0.5em 1em;

        @media screen and (max-width: 620px) {
          font-size: 0.5em;
          bottom: -0.6em;
        }
      }

      &--active {
        background-color: $green;
        color: $blue;
      }

      @media screen and (max-width: 900px) {
        &__icon {
          height: 24px;
          width: 24px;
          margin-left: 0.5rem;

          & img {
            height: 24px;
            width: 24px;
          }
        }
      }
    }
  }

  & .separator {
    align-self: center;
    height: 1em;
    border-right: 1px dotted $green;
    margin: 0 0.4em;
  }

  @media screen and (max-width: 800px) {
    column-gap: 0.5em;
    padding: 10px;

    &__item {
      &__button {
        font-size: 1rem;
      }
    }
  }

  @media screen and (max-width: 510px) {
    &__item {
      &__button {
        font-size: 0.75em;
        height: 48px;
        align-self: center;
        white-space: nowrap;
      }
    }
  }

  @media screen and (max-width: 510px) {
    padding: 5px 20px;
    &__item {
      &__button {
        padding: 0 0.8em;
        font-size: 0.75em;
        height: 40px;
        align-self: center;
        white-space: nowrap;

        &__icon {
          height: 16px;
          width: 16px;
          margin-right: 0.3rem;

          & img {
            height: 16px;
            width: 16px;
          }
        }
      }
    }
  }
}

.disabled {
  cursor: default;
  opacity: 0.6;
}
</style>
